module.exports = __webpack_public_path__ + "img/2022_gyeonggi_open.cad14daf.png";